import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import GetQrLink from "./getQrLink";
export { GetQrLink };

export const MultiUrlAPI = async (data) => {
  let requestStr = "";
  const formData = new FormData();
  formData.append(`qrTitle`, data.qrTitle);
  formData.append(`defaultUrl`, data.defaultUrl);
  formData.append(`advertisingIabCategories[]`, data.category);
  if (data.typeQr === 1) {
    requestStr = "location";
    formData.append(`locations`, JSON.stringify(data.locations));
  } else if (data.typeQr === 2) {
    requestStr = "scans";
    formData.append(`scans`, JSON.stringify(data.scans));
  } else if (data.typeQr === 3) {
    requestStr = "time";
    formData.append(`times`, JSON.stringify(data.times));
  } else if (data.typeQr === 4) {
    requestStr = "language";
    formData.append(`languages`, JSON.stringify(data.languages));
  }
  const response = await axios({
    url: `/multi-url/${requestStr}/ajax/${
      data.id === null ? "new" : `edit/${data.id}`
    }`,
    method: "POST",
    data: formData,
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const FetchMultiUrlData = createAsyncThunk(
  "FetchMultiUrlData",
  async (id) => {
    let response = null;
    let qrTitle = "";
    let adsCategories = "";
    try {
      const { data } = await axios.get(`/multi-url/${id}`);
      response = data[0] || {
        multiUrlLanguages: [],
        multiUrlLocations: [],
        multiUrlScansQties: [],
        multiUrlTimes: [],
      };
      qrTitle = data.qrTitle;
      adsCategories = data.adsCategories;
    } catch (error) {
      throw new Error(error.response.status);
    }

    const locations = response.multiUrlLocations.map(
      ({ id, city, country, locationUrl }) => ({
        id,
        countryId: country?.id || "",
        cityId: city?.id || "",
        link: locationUrl,
        linkValid: true,
      })
    );

    const languages = response.multiUrlLanguages.map(
      ({ id, language, languageUrl }) => ({
        id,
        languageId: language.id,
        link: languageUrl,
        linkValid: true,
      })
    );

    const numberOfScans = response.multiUrlScansQties.map(
      ({ id, scans, scansUrl }) => ({
        id,
        scanNumber: scans,
        link: scansUrl,
        linkValid: true,
      })
    );

    const times = response.multiUrlTimes.map(
      ({ id, timezone, startTime, endTime, timeUrl }) => {
        const start = new Date(startTime);
        const end = new Date(endTime);
        return {
          id,
          timezoneId: timezone.id,
          startTime: `${String(start.getHours()).padStart(2, "0")}:${String(
            start.getMinutes()
          ).padStart(2, "0")}`,
          endTime: `${String(end.getHours()).padStart(2, "0")}:${String(
            end.getMinutes()
          ).padStart(2, "0")}`,
          link: timeUrl,
          linkValid: true,
        };
      }
    );

    const type =
      response.type === 1
        ? 4
        : response.type === 2
        ? 1
        : response.type === 3
        ? 2
        : response.type === 4
        ? 3
        : 1;

    return {
      defaultUrl: response.defaultUrl || "",
      locations,
      languages,
      times,
      numberOfScans,
      type,
      qrTitle,
      adsCategories,
    };
  }
);
